import React from 'react'
import welcome_large_image from "../assets/welcome_large_image.jpg"
import welcome_small_image from "../assets/welcome_small_image.jpg"

// icons start 
import { FaCheck } from "react-icons/fa6";
// icons end 
const BelowService = () => {
    return (
        <div>
            <div className='flex justify-center gap-[30px] my-[100px]'>
                <div className='left_container relative w-[40%]'>
                    <div className='flex justify-center'>
                        <div className=' w-[550px] '>
                            <img className='rounded-[140px]' src={welcome_large_image} alt="" />
                        </div>
                        <div className='absolute  right-[30px] -bottom-[80px]   w-[250px]  rounded-[50px] '>
                            <img className='border-[10px] border-white  rounded-[85px]' src={welcome_small_image} alt="" />
                        </div>
                    </div>
                </div>



                <div className='right_container w-[40%]'>
                    <div className='flex justify-center flex-col'>
                        <div className='heading_container text-start w-[100%] leading-[45px] pb-[20px]'>
                            <p className='text-main-color font-sans font-semibold text-[21px]'>Welcome To WonderKids</p>
                            <h3 className='text-[41px] text-[#161616] font-semibold'>We Are Here to Bring</h3>
                            <h3 className='text-[41px] text-[#161616] font-semibold'>Your Child Next Level</h3>
                        </div>
                        <div className='w-[80%]'>
                            <p className='font-sans text-[16px] text-[#161616] font-normal'>Pellentesque habitant morb tristique senectus netus malesu ada faes ac turpis egestas. Vivamus imperdiet utrumhicula. Mauris ornare turpis diam, sed commodo nunc susci pitacyi and Mauris ut ultricies turpis.</p>
                        </div>

                        <div className='py-[30px] w-[80%]'>
                            <div className="flex justify-between  text-black  pb-[20px]">
                                <div className='flex items-center gap-3'><span className='w-[40px] h-[40px] rounded-full bg-[#ed5d74] flex justify-center items-center'><FaCheck  color='white'/></span><span className='text-[20px] font-medium'>Expert Trainers</span></div>
                                <div className='flex items-center gap-3'><span className='w-[30px] h-[30px] rounded-full bg-[#6453ee] flex justify-center items-center'><FaCheck  color='white'/></span><span className='text-[20px] font-medium'>Expert Trainers</span></div>
                            </div>
                            <div className="flex justify-between  text-black pb-[20px]">
                                <div className='flex items-center gap-3'><span className='w-[40px] h-[40px] rounded-full bg-[#ffb132] flex justify-center items-center'><FaCheck  color='white'/></span><span className='text-[20px] font-medium'>Expert Trainers</span></div>
                                <div className='flex items-center gap-3'><span className='w-[30px] h-[30px] rounded-full bg-[#01c8c5] flex justify-center items-center'><FaCheck  color='white'/></span><span className='text-[20px] font-medium'>Expert Trainers</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BelowService